/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaUiCirclePlayIcon20Solid = forwardRef('MediaUiCirclePlayIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm-1.834-4.069a.6.6 0 0 1-.916-.51V6.58a.6.6 0 0 1 .916-.51L13.68 9.49a.6.6 0 0 1 0 1.02L8.166 13.93Z" })));
});
